'use strict';

/**
 * Imports
 */
import URI from 'urijs';

let uri = new URI();

if (uri.filename() === 'index.php') {
    uri.filename('');
}

for (let el of document.querySelectorAll('.module-navigation a[href]')) {
    let target = new URI(el);
    if (target.filename() === uri.filename()) {
        el.setAttribute('aria-current', 'page');
    }
}


// WEBPACK FOOTER //
// ./public/global/resources/js/nav-external.js